import dayjs from 'dayjs';

import { dateFormat, dateTimeFormat } from '@/constants/dates/dates';

export const formatDate = (date: string) => dayjs(new Date(date)).format(dateFormat);
export const formatDateTime = (date: Date, format?: string) =>
    dayjs(new Date(date)).format(format ?? dateTimeFormat);
